const domain = process.env.REACT_APP_BASE_URL

export const specificPayrollURL = domain + "run-pay-roll-specific-employee.php"
export const departmentPayrollURL = domain + "run-payroll-by-department.php"
export const payrollURL=domain + "run-payroll.php"
export const sendSliptURL = domain + "send-payslips.php"
export const sendApprovalURL = domain + "request-payroll-approval.php"
export const payrollByIDURL = domain + "get-payroll-by-id.php"
export const payrollForFoundationalURL = domain + "run-payroll-by-foundation-object.php"
export const confirmApprovalForPayrollURL = domain + "approve-payroll.php"
export const rejectApprovalForPayrollURL = domain + "reject-payroll.php"
export const PayrollHistoryURL = domain + "get-payroll-history.php"
export const CurrentMonthPayrollURL = domain + "get-payroll-current-month.php"
export const payrollApprovalURL = domain + "approve-payroll.php"
export const loginURL = domain + "login.php";
export const allEmployeeURL= domain + "get-all-employees.php"
export const employeeByIDURL = domain + "get-employee-by-id.php"
export const creatEmployeeURL = domain + "create-employee.php"
export const addContactURL = domain + "add-contact-information.php"
export const addEmploymentURL = domain + "add-employee-employment.php"
export const addCareerHistoryURL = domain + "add-career-history.php"
export const addWagesURL = domain + "add-salary-info.php"
export const creatTableOfRateURL = domain + "create-table-of-rate.php"
export const updateTableOfRateURL = domain + "update-table-of-rate.php"
export const allTableOfRateURL = domain + "get-all-table-of-rate.php"
export const creatPayItemURL = domain + "create-payroll-item.php"
export const updatePayItemURL = domain + "update-payroll-item.php"
export const payItemByIDURL = domain + "get-payroll-item-by-id.php"
export const allPayItemURL=domain + "get-payroll-items.php"
export const creatLegalEntityURL = domain + "create-legal-entity-country-specific.php"
export const allLegalEntitiesURL= domain + "get-all-legal-entity-country-specific.php"
export const editLegalEntitiesURL= domain + "edit-legal-entity-country-specific.php"
export const deleteLegalEntitiesURL= domain + "delete-legal-entity-country-specific.php"
export const creatBusinessUnitURL = domain + "create-business-unit.php"
export const allBusinessUnitURL = domain + "get-all-business-units.php"
export const createDivisionURL = domain + "create-division.php"
export const allDivisionURL = domain + "get-all-division.php"
export const creatDepartmentURL = domain + "create-department.php"
export const allDepartmentURL = domain + "get-all-department.php"
export const creatPayGradeURL = domain + "create-pay-grade.php"
export const allPayGradeURL = domain + "get-all-pay-grades.php"
export const creatPayLevelURL = domain + "create-pay-level.php"
export const allPayLevelURL = domain + "get-all-pay-levels.php"
export const createEmployeePersonalURL = domain + "new-employee.php";
export const allLocationURL = domain + "get-all-locations.php"
export const createLocationURL = domain + "create-location.php"
export const updatePersonalInfoURL = domain + "update-employee-personal-details.php"
export const requestLeaveTypeURL = domain + "get-all-leave-types.php"
export const addLeaveTypeURL = domain + "create-leave-type.php"
export const updateLeaveTypeURL = domain + "edit-leave-type.php"
export const deleteLeaveTypeURL = domain + "delete-leave-type.php"
export const requestLeaveURL = domain + "request-leave.php"
export const requestLeaveHistoryURL = domain + "get-leave-history.php"
export const requestLeaveReportURL = domain + "get-leave-report.php"
export const requestLoanURL = domain + "request-loan.php"
export const assignedLeaveRequestsURL = domain + "get-assigned-leave-requests.php"
export const assignedLoanRequestsURL = domain + "get-assigned-loan-requests.php"
export const requestLoanHistoryURL = domain + "get-loan-history.php"
export const getLoanSettingsUrl = domain + "get-loan-settings.php"
export const updateLoanSettingsUrl = domain + "update-loan-settings.php"
export const dashboardStatsURL = domain + "get-dashboard-stats.php"
export const allNotificationsURL = domain + "get-employee-notifications.php"
export const approveLeaveRequestURL = domain + "approve-leave-request.php"
export const denyLeaveRequestURL = domain + "deny-leave-request.php"
export const approveLoanRequestURL = domain + "approve-loan.php"
export const denyLoanRequestURL = domain + "deny-loan.php"
export const allStatesURL = domain + "get-states-by-country.php"
export const allCitiesURL = domain + "get-cities-by-country-and-state.php"
export const verifyAccountNameURL = domain + "verify-account-name.php"
export const allLoanTypesURL = domain + "get-all-loan-types.php"
export const repaymentScheduleURL = domain + "get-loan-repayment-schedule.php"
export const createLoanTypeURL = domain + "create-loan-type.php"
export const updateLoanTypeURL = domain + "update-loan-type.php"
export const deleteLoanTypeURL = domain + "delete-loan-type.php"
export const eligiblePercentPerPayURL = domain + "get-eligible-percentage-pay-items.php"
export const allJobRolesURL = domain + "get-all-job-roles.php"
export const addJobRolesURL = domain + "create-job-role.php"
export const updateJobRolesURL = domain + "edit-job-role.php"
export const deleteJobRolesURL = domain + "delete-job-role.php"
export const payLevelByPayGradeURL = domain + "get-paylevels-by-paygrade.php"
export const allPayrollTaxBandURL = domain + "get-payroll-tax-bands.php"
export const updatePayrollTaxBandURL = domain + "edit-payroll-tax-bands.php"
export const allAddressTypesUrl = domain + "get-all-address-types.php"
export const createAddressTypesUrl = domain + "create-address-type.php"
export const updateAddressTypesUrl = domain + "edit-address-type.php"
export const deleteAddressTypesUrl = domain + "delete-address-type.php"
export const allFoundationStatsUrl = domain + "get-employee-count-for-all-foundations.php"
export const activateEmployeeUrl = domain + "make-employee-active.php"
export const deactivateEmployeeUrl = domain + "make-employee-inactive.php"
export const generatePayrollBankReportUrl = domain + "generate-payroll-bank-report.php"
export const generatePayrollPAYE = domain + "generate-payroll-paye-report.php"
export const generatePayrollSummaryUrl = domain + "get-payroll-summary-report.php"
export const generatePayrollPension = domain + "generate-payroll-pension-report.php"
export const disburseAdvanceUrl = domain + "disburse-employee-advance.php"
export const allAdvancementsUrl = domain + "get-all-advances.php"
export const getEmployeePayItemsUrl = domain + "get-employee-pay-items.php"
export const updateEmployeePayItemsUrl = domain + "update-employee-pay-items.php"
export const getPrintoutPayItemsUrl = domain + "get-printout-pay-items.php"
export const updatePrintoutPayitemUrl = domain + "update-printout-pay-items.php"
export const getAllPermissionsUrl = domain + "get-all-roles.php"
export const getAssignedEmployeesUrl = domain + "get-all-employee-roles.php"
export const getAllPermissionRolesUrl = domain + "get-all-permission-roles.php"
export const createPermissionRoleUrl = domain + "create-role.php"
export const assignEmployeeRoleUrl = domain + "assign-employee-to-role.php"
export const removeEmployeeRoleUrl = domain + "remove-employee-from-role.php"
export const updatePaystackAccUrl = domain + "update-paystack-account.php"
export const getPaystackAccUrl = domain + "get-paystack-account.php"
export const proxyEmployeeUrl = domain + "start-proxy-employee.php"
export const stopProxyEmployeeUrl = domain + "stop-proxy-employee.php"
export const updatePermissionRoleUrl = domain + "update-role.php"
export const payItemBySalaryUrl = domain + "get-employee-pay-items-by-annual-salary.php"
export const sendSMSUrl = domain + "send-employee-sms.php"
export const sendEmailUrl = domain + "send-employee-email.php"
export const updatePayrollSettingsUrl = domain + "update-payroll-settings.php"
export const getPayrollSettingsUrl = domain + "get-payroll-settings.php"
export const sendPayrollPaymentUrl = domain + "send-payroll-payments.php"
export const salaryBreakdownUrl = domain + "get-employee-salary-breakdown.php"
export const uploadPicUrl = domain + "upload-image.php"
export const changePicUrl = domain + "update-employee-profile-picture.php"
export const changeCompanyLogoUrl = domain + "update-company-logo.php"
export const changeCompanyColorUrl = domain + "update-company-color-theme.php"
export const createWorkHoursUrl = domain + "create-employee-work-hour.php"
export const updateWorkHoursUrl = domain + "edit-employee-work-hour.php"
export const deleteWorkHoursUrl = domain + "delete-employee-work-hour.php"
export const getAllWorkHoursUrl = domain + "get-all-employee-work-hours.php"
export const createEmploymentTypeUrl = domain + "create-employment-type.php"
export const updateEmploymentTypeUrl = domain + "edit-employment-type.php"
export const deleteEmploymentTypeUrl = domain + "delete-employment-type.php"
export const getAllEmploymentTypeUrl = domain + "get-all-employment-types.php"
export const repayLoanUrl = domain + "repay-loan.php"
export const getEmployeeNumSettingsUrl = domain + "get-employee-number-settings.php"
export const updateEmployeeNumSettingsUrl = domain + "update-employee-number-settings.php"
export const editDeparmentUrl = domain + "edit-department.php"
export const deleteDepartmentUrl = domain + "delete-department.php"
export const editDivisionUrl = domain + "edit-division.php"
export const deleteDivisionUrl = domain + "delete-division.php"
export const editBusinessUnitUrl = domain + "edit-business-unit.php"
export const deleteBusinessUnitUrl = domain + "delete-business-unit.php"
export const editLocationUrl = domain + "edit-location.php"
export const deleteLocationUrl = domain + "delete-location.php"
export const editPayLevelUrl = domain + "edit-pay-level.php"
export const deletePayLevelUrl = domain + "delete-pay-level.php"
export const editPayGradeUrl = domain + "edit-pay-grade.php"
export const deletePayGradeUrl = domain + "delete-pay-grade.php"
export const updateWorkDayTypeUrl = domain + "update-company-work-day-type.php"
export const numberOfLeaveDaysUrl = domain + "get-number-of-leave-days.php"
export const fetchCompaniesUrl = domain + "get-all-companies.php"
export const createCompanyUrl = domain + "create-company.php"
export const companyByIdUrl = domain + "get-company-by-id.php"
export const loginAdminUrl = domain + "login.php"
export const getOvertimeSettingsUrl = domain + "get-overtime-settings.php"
export const updateOvertimeSettingsUrl = domain + "update-overtime-settings.php"
export const updateLeaveSettingsUrl = domain + "update-leave-settings.php"
export const getLeaveSettingsUrl = domain + "get-leave-settings.php"
export const getCurrencyConvertUrl = domain + "get-currency-converter.php"
export const updateCurrencyConvertUrl = domain + "update-currency-converter.php"
export const deleteCompanyUrl = domain + "delete-company.php"
export const fetchAdminsUrl = domain + "get-all-admins.php"
export const addAdminUrl = domain + "create-admin.php"

// export const unReadNotificationsURL = domain + "get-dashboard-stats.php"